import React, { Component } from 'react'
import { Message } from '@paypalcorp/worldready-react'

import { constants } from '../constants/constants'
import { fileOptionsConstants } from '../constants/fileOptions'
import MoveOrCopy from './MoveOrCopy'
import { getKeyByValue } from '../helper'

class Buttons extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      selectedOptionList: '',
    }
  }

  onButtonClick = (value, render) => {
    const {
      multipleSelectItems,
      baseFolder,
      selectedFolderToSearch,
    } = this.props
    if (!render) {
      return
    }
    if (value === 'Upload Files') {
      this.props.setUploadFileBoxVisibility(true)
    } else if (value === 'Create Folder') {
      this.props.setCreateNewFolderVisibility(true)
    } else if (value === 'Share') {
      if (
        baseFolder !== '/' &&
        baseFolder !== '_fv_root' &&
        baseFolder !== '' &&
        multipleSelectItems.length === 0
      ) {
        this.props.onOptionsClick(selectedFolderToSearch, value)
      }
      multipleSelectItems.map((file) => {
        this.props.onOptionsClick(file, value)
      })
    } else if (value === 'Download') {
      multipleSelectItems.map((file) => {
        this.props.onOptionsClick(file, value)
      })
    } else if (value === 'Delete') {
      this.props.onOptionsClick(multipleSelectItems, value)
    } else if (value === 'Move to') {
      this.setState({ selectedOptionList: 'Move to' })
      this.props.onOptionsClick(multipleSelectItems, value)
    } else if (value === 'Copy to') {
      this.setState({ selectedOptionList: 'Copy to' })
      this.props.onOptionsClick(multipleSelectItems, value)
    }
  }

  renderViewToggleButton = () => {
    const { viewType } = this.props
    return (
      <div className="change_view-conatiner">
        <div className="ppvx_btn ppvx_btn--secondary ppvx_btn--size_sm switch__button-container ">
          {constants.ViewTypes.map((item, index) => {
            return (
              <div
                key={`${item.name}_${index}`}
                className={`switch__button ${
                  viewType === item.key ? 'switch__button--selected' : ''
                }`}
                onClick={() => this.props.changeView(item.key)}
              >
                <span
                  className={`ppvx_icon ppvx_icon--size_sm switch__button-icon  ${item.icon}`}
                />
                <span className="hide_mobile">{item.name}</span>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  checkButtonVisibility = (item) => {
    const { options } = this.props
    const isButtonMatches = options.filter(function (button) {
      return button.option === item.option
    })
    return isButtonMatches.length > 0
  }

  checkDefaultButtonVisibility = (options) => {
    const { user, baseFolder, userPermission, multipleSelectItems } = this.props

    if (user.accType === constants.AdhocUser && baseFolder === '/') {
      return false
    } else if (!options.renderOnlyWithPermission.includes(userPermission)) {
      return false
    } else if (multipleSelectItems.length > 0) {
      return false
    }
    return true
  }

  renderMoreOptions = () => {
    const {
      showMoveOrCopyToList,
      moveOrCopyFolderDetails,
      folderListFetchInProgress,
      itemToCopy,
      itemToMove,
    } = this.props
    return (
      showMoveOrCopyToList && (
        <MoveOrCopy
          {...this.props}
          moveOrCopyFromButton={true}
          moveOrCopyFolderDetails={moveOrCopyFolderDetails}
          folderListFetchInProgress={folderListFetchInProgress}
          selectedOptionList={this.state.selectedOptionList}
          fetchSearchDataForMoveCopy={this.props.fetchSearchDataForMoveCopy}
          pasteFile={this.props.pasteFile}
          fileOptionStatus={this.props.fileOptionStatus}
          itemToCopy={itemToCopy}
          itemToMove={itemToMove}
        />
      )
    )
  }

  refClassName = (item) => {
    return item.option === 'Move to' || item.option === 'Copy to'
      ? 'moveorcopy'
      : ''
  }

  renderButtons = () => {
    const {
      defaultButtons,
      user,
      hasItemToMove,
      hasItemToCopy,
      multipleSelectItems,
    } = this.props
    return (
      <div className="buttons-content">
        {fileOptionsConstants.FileOptionsOutside.map((item) => {
          return item.type === 'default'
            ? item.options.map((options) => {
                return options.renderFor.includes(user.accType) ? (
                  <div className="buttons-list" key={options.option}>
                    <a
                      id={`${options.key}Button`}
                      className={`ppvx_link flexCenter uploadButton ${
                        this.checkDefaultButtonVisibility(options)
                          ? ''
                          : 'button-disabled'
                      }`}
                      onClick={() =>
                        this.onButtonClick(
                          options.option,
                          this.checkDefaultButtonVisibility(options),
                        )
                      }
                    >
                      <span
                        className={`ppvx_icon ppvx_icon--size_sm uploadButton ${options.icon}`}
                      />
                      <span className="hide_mobile uploadButton">
                        <Message
                          id={`buttons.${
                            getKeyByValue(
                              fileOptionsConstants.LocalizeIdForMoreOptions,
                              options.option,
                            ).localizeId
                          }`}
                        />
                      </span>
                    </a>
                  </div>
                ) : (
                  ''
                )
              })
            : ''
        })}

        {defaultButtons.length > 0 &&
          defaultButtons.map((item, index) => {
            return (
              <div key={index}>
                <div className="buttons-list">
                  <a
                    id={`${item.key}Button`}
                    className={`ppvx_link flexCenter buttonoptions ${
                      this.checkButtonVisibility(item) ? '' : 'button-disabled'
                    } ${this.refClassName(item)}`}
                    onClick={() =>
                      this.onButtonClick(
                        item.option,
                        this.checkButtonVisibility(item),
                      )
                    }
                  >
                    <span
                      className={`ppvx_icon ppvx_icon--size_sm buttonoptions ${
                        item.icon
                      } ${this.refClassName(item)}`}
                    />
                    <span
                      className={`hide_mobile buttonoptions ${this.refClassName(
                        item,
                      )}`}
                    >
                      <Message
                        id={`buttons.${
                          getKeyByValue(
                            fileOptionsConstants.LocalizeIdForMoreOptions,
                            item.option,
                          ).localizeId
                        }`}
                      />
                    </span>
                  </a>
                </div>
                {((item.option === 'Move to' && hasItemToMove) ||
                  (item.option === 'Copy to' && hasItemToCopy)) &&
                  multipleSelectItems.length > 0 && (
                    <div
                      className={`ppvx_overflow-menu ${this.refClassName(
                        item,
                      )}`}
                      key="more"
                    >
                      {this.renderMoreOptions()}
                    </div>
                  )}
              </div>
            )
          })}
      </div>
    )
  }

  render() {
    const { options, defaultButtons } = this.props
    return (
      (defaultButtons.length !== 0 || options.length !== 0) && (
        <div className="buttons-container">
          {this.renderButtons()}
          {constants.ShowViews && this.renderViewToggleButton()}
        </div>
      )
    )
  }
}

export default Buttons
